import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import ProtectedRoute, { defaultHomeFor } from "@/components/ProtectedRoute";

import Login from "@/pages/Login";

import AdminLayout from "@/components/AdminLayout";
import Dashboard from "@/pages/Dashboard";
import NuevoPedido from "@/pages/NuevoPedido";
import Pedidos from "@/pages/Pedidos";
import PedidoDetalle from "@/pages/PedidoDetalle";
import Remitos from "@/pages/Remitos";
import Clientes from "@/pages/Clientes";
import Productos from "@/pages/Productos";
import Insumos from "@/pages/Insumos";
import Cuenta from "@/pages/Cuenta";
import CuentaCorriente from "@/pages/CuentaCorriente";
import Auditoria from "@/pages/Auditoria";
import Stock from "@/pages/Stock";
import Produccion from "@/pages/Produccion";

import ClienteLayout from "@/components/ClienteLayout";
import ClienteCatalogo from "@/pages/cliente/Catalogo";
import ClienteCarrito from "@/pages/cliente/Carrito";
import ClienteMisPedidos from "@/pages/cliente/MisPedidos";
import ClienteMiPedidoDetalle from "@/pages/cliente/MiPedidoDetalle";

import StaffLayout from "@/components/StaffLayout";
import Despacho from "@/pages/Despacho";

function HomeRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={defaultHomeFor(user.role)} replace />;
}

function StaffIndexRedirect() {
  const { user } = useAuth();
  // elaborador defaults to cocina, repartidor to despacho
  const target = user?.role === "repartidor" ? "/staff/despacho" : "/staff/cocina";
  return <Navigate to={target} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Routes>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/login" element={<Login />} />

            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["admin", "encargado"]}>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<ProtectedRoute role="admin"><Dashboard /></ProtectedRoute>} />
              <Route path="pedidos" element={<Pedidos />} />
              <Route path="pedidos/:id" element={<PedidoDetalle />} />
              <Route path="remitos" element={<Remitos />} />
              <Route path="clientes" element={
                <ProtectedRoute roles={["admin"]}><Clientes /></ProtectedRoute>
              } />
              <Route path="cuenta-corriente" element={<CuentaCorriente />} />
              <Route path="cuenta-corriente/:cid" element={<CuentaCorriente />} />
              <Route path="productos" element={<Productos />} />
              <Route path="insumos" element={<ProtectedRoute role="admin"><Insumos /></ProtectedRoute>} />
              <Route path="stock" element={<ProtectedRoute role="admin"><Stock /></ProtectedRoute>} />
              <Route path="despacho" element={<ProtectedRoute role="admin"><Despacho /></ProtectedRoute>} />
              <Route path="produccion" element={<Produccion />} />
              <Route path="auditoria" element={
                <ProtectedRoute roles={["admin"]}><Auditoria /></ProtectedRoute>
              } />
              <Route path="carga-rapida" element={<NuevoPedido />} />
              <Route path="cuenta" element={<Cuenta />} />
            </Route>

            <Route
              path="/staff"
              element={
                <ProtectedRoute roles={["admin", "encargado", "repartidor", "elaborador"]}>
                  <StaffLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<StaffIndexRedirect />} />
              <Route path="cocina" element={
                <ProtectedRoute roles={["admin", "encargado", "elaborador"]}>
                  <Produccion />
                </ProtectedRoute>
              } />
              <Route path="despacho" element={
                <ProtectedRoute roles={["admin", "encargado", "repartidor"]}>
                  <Despacho />
                </ProtectedRoute>
              } />
            </Route>

            <Route
              path="/cliente"
              element={
                <ProtectedRoute roles={["cliente"]}>
                  <ClienteLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<ClienteCatalogo />} />
              <Route path="carrito" element={<ClienteCarrito />} />
              <Route path="pedidos" element={<ClienteMisPedidos />} />
              <Route path="pedidos/:id" element={<ClienteMiPedidoDetalle />} />
            </Route>

            <Route path="*" element={<HomeRedirect />} />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
